/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Happy_Dove_ActInputs */

const en_gray_happy_dove_act = /** @type {(inputs: Gray_Happy_Dove_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_gray_happy_dove_act = /** @type {(inputs: Gray_Happy_Dove_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Gray_Happy_Dove_ActInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_happy_dove_act = /** @type {((inputs?: Gray_Happy_Dove_ActInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Happy_Dove_ActInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_happy_dove_act(inputs)
	return de_gray_happy_dove_act(inputs)
});